import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { StoreId } from "../../../../../types";
import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories";
import image from "../../../assets/Assets-V4/WiFi/e7-aud@2x.jpg";
import v3Image from "../../../assets/WiFi/e7-audience.jpg";
import type { Product } from "../../../types";
import { wifiE7 } from "../../product-list-groups/wifi-e7";
import {
  antennaType,
  connectedDevices,
  dedicatedSpectral,
  extendedRangeMode6Ghz,
  fipsCompliance,
  powerMethodPoe,
  radio6Ghz,
  redundantRj45Port,
  rfFilteringTechnology,
  uplink,
  weatherproofing,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../../properties";

export const sharedE7AudienceData: Product = {
  id: "e7Audience",
  productTitle: "E7 Audience",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.WiFi}/e7-audience-us`,
  ],
  storePathParts: (storeId) => {
    switch (storeId) {
      case StoreId.Us:
      case StoreId.Ca:
        return { productSlug: "e7-audience-us", category: "wifi-enterprise" };
      default:
        return { productSlug: "e7-audience", category: "wifi-enterprise" };
    }
  },
  descriptionMaxWidth: 320,
  sku: "E7-Audience",
  description: "e7Audience.description",
  isNew: true,
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 328,
    height: 182.5,
  },
  productListGroup: wifiE7,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value:
          'Device: 474.1 x 265.5 x 42.2 mm\n(18.7 x 10.5 x 1.7")\n\n\nBracket: 150.4 x 113.6 x 125 mm\n(5.9 x 4.5 x 4.9")',
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "e7Audience.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: extendedRangeMode6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: dedicatedSpectral.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: rfFilteringTechnology.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: antennaType.id,
      value: {
        type: "translation",
        value: "e7Audience.antennaType.selectableDirectional",
        asterisk: 2,
      },
    },
    {
      propertyId: wifiCoverage.id,
      value: {
        type: "translation",
        value: "e7Audience.wifiCoverage",
      },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "1,500+" },
    },
    {
      propertyId: weatherproofing.id,
      value: { type: "string", value: "IP68", asterisk: 1 },
    },
    {
      propertyId: powerMethodPoe.id,
      value: { type: "string", value: "PoE++" },
    },
    {
      propertyId: uplink.id,
      value: { type: "string", value: "10 GbE" },
    },
    {
      propertyId: redundantRj45Port.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.wallPole",
      },
    },
    {
      propertyId: fipsCompliance.id,
      value: { type: "boolean", value: true, asterisk: 4 },
    },
  ],
  notes: ["e7Audience.notes.1", "e7Audience.notes.2"],
};
